import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import H2 from '@base/H2/H2';
import Paper from '@base/Paper/Paper';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import { getTopologyDataByUID } from '@selectors/topologies';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import breadcrumbs, { goBack } from '@utils/breadcrumbs';
import { Spacings } from '@styles/index';
import { useSelector } from 'react-redux';
import {
  getIsSubscribedToLite,
  getIsSubscribedToOffline
} from '@selectors/subscription';
import ReminderActions from './ReminderActions';

const Wrapper = styled(Paper)`
  margin-bottom: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_12B};
`;

const Title = styled(H2)`
  margin-top: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
`;

const Header = () => {
  const router = useRouter();
  const { goalUID } = router.query;

  const goalTopology = useSelectorWithShallowEqual(
    getTopologyDataByUID(goalUID)
  );
  const isLiteUser = useSelector(getIsSubscribedToLite(goalUID));

  const getTags = (isOfflineSubscription) => {
    const tags = [];
    if (goalTopology) {
      tags.push(
        ...breadcrumbs.getPlusTopicsTags(goalTopology, isOfflineSubscription)
      );
    }

    return tags;
  };

  const { isRecordedGoal } = goalTopology || {};
  const isOfflineSubscription = useSelector(getIsSubscribedToOffline(goalUID));
  const headerTags = getTags(isOfflineSubscription);

  return (
    <Wrapper gridColumn="span 18">
      {!isLiteUser && !isRecordedGoal && <ReminderActions />}
      <BreadCrumbs tags={headerTags} onBackClick={goBack} useBackClick />
      <Title>Practice</Title>
    </Wrapper>
  );
};

export default Header;
